import { render, staticRenderFns } from "./fz_alterLicense.vue?vue&type=template&id=c86f5c46&"
import script from "./fz_alterLicense.vue?vue&type=script&lang=js&"
export * from "./fz_alterLicense.vue?vue&type=script&lang=js&"
import style0 from "./fz_alterLicense.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports